import { Component, Input } from '@angular/core';

@Component({
  selector: 'share-page-header',
  templateUrl: './share-page-header.component.html'
})
export class SharePageHeaderComponent {
  @Input() title = '';
  @Input() subtitle = '';
}
